export type Typify<T> = { [K in keyof T]: T[K] };
type TKey = number | string | symbol;
type THash<T> = Record<number | string, T>;
type TData<T> = T[];
interface INormalizeDataReturn<T> {
  list: TData<T>;
  hash: THash<T>;
}

export function normalizeData<T extends Record<string, unknown>>(
  data: TData<T>,
  key: string = 'id',
): INormalizeDataReturn<T> {
  return data.reduce<INormalizeDataReturn<T>>(
    (acc, curr) => {
      const k = curr[key];

      if (isKey(k)) {
        return { hash: { ...acc.hash, [k]: curr }, list: [...acc.list, curr] };
      }

      return acc;
    },
    { hash: {}, list: [] },
  );
}

function isKey(value: unknown): value is TKey {
  return ['string', 'number', 'symbol'].includes(typeof value);
}
